module.exports = {
  'Yes':'Yes',
  'No':'No',
  'Unknown':'Unknown'
};
